// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ComponentFragmentDoc } from '../cms/CmsComponent.fragment.generated';
export const PdpAccordionItemFragmentDoc = gql`
    fragment pdpAccordionItem on ProductPageDetailsAccordionItem {
  __typename
  expanded
  ... on ProductPageDetailsAccordionItemGeneric {
    title
    components {
      ...component
    }
  }
  ... on ProductPageDetailsAccordionItemFinance {
    components {
      ...component
    }
  }
  ... on ProductPageDetailsAccordionItemShipping {
    components {
      ...component
    }
  }
  ... on ProductPageDetailsAccordionItemSizing {
    components {
      ...component
    }
  }
  ... on ProductPageDetailsAccordionItemWarranty {
    components {
      ...component
    }
  }
}
    ${ComponentFragmentDoc}`;